import * as a from "react";
import t from "../lib/IconBase.es.js";
import n from "../defs/HandHeart.es.js";
const e = a.forwardRef((o, r) => /* @__PURE__ */ a.createElement(t, { ref: r, ...o, weights: n }));
e.displayName = "HandHeartIcon";
const s = e;
export {
  s as HandHeart,
  e as HandHeartIcon
};
